<div class="h-100 d-flex justify-content-end align-items-center m-0 mr-2">
  <div class="custom-control custom-checkbox m-2">
    <input
      type="checkbox"
      class="custom-control-input"
      id="search-results-show-only-active"
      [ngModel]="active"
      (click)="onCheckboxClicked()" />
    <label class="custom-control-label" for="search-results-show-only-active">{{
      '$search_show_only_active_customers$' | translate
    }}</label>
  </div>
</div>
